
export default function () {

    const $button = $('.js-header-pop-open');
    const $target = $('.js-header-pop-target');

    // スマホ用：メニュー開閉ボタン
    $button.on('click', open_close_menu);

    // メニューのボタンを押した
    $('.l-header a.js-pagescroll').on('click', close_menu);

    /**
     * 閉じたり開いたり
     */
    function open_close_menu(e) {
        e.preventDefault();
        const status = $target.attr('data-sp-menu');

        // メニュー
        $target.attr('data-sp-menu', status !== 'open' ? 'open' : 'close');
        // 開閉ボタン
        $(this).attr('data-sp-menu', status !== 'open' ? 'open' : 'close');

    }

    /**
     * メニューのボタンを押した
     * @param {*} e クリックイベント
     */
    function close_menu(e) {
        e.preventDefault();

        console.log("click");

        $target.attr('data-sp-menu', 'close');
        $button.attr('data-sp-menu', 'close');

    }

}



// WEBPACK FOOTER //
// ./js/module/menu.js